import Component from 'vue-class-component';
import { ClubCardUser, UserApiService, ClubCardUserResponse, UserRegisterResponse, SecurityQuestion } from '@/services/generated/edge/user';
import { RegistrationVue } from '@/registration-vue';
import './fresh-registration.scss';
declare var dataLayer: any;
@Component({ template: require('./fresh-registration.html') })
export class FreshRegistrationPage extends RegistrationVue {

  passwordFocused: boolean = false;
  loading: boolean = false;

  mounted() {
    dataLayer.push({
      'event': 'stepLoaded',
      'stepNumber': '3',
      'stepName': 'Enter mobile number and password'
    });
    this.$validator.updateDictionary({
      en: {
        custom: {
          mobileNumber: {
            required: 'Please enter your mobile number',
          },
          password: {
            required: 'Please set up a password'
          },
          agree: {
            required: 'Please agree to sign up'
          },
        }
      }
    });
  }

  toggleShowPassword() {
    this.$refs.passwordField['type'] = this.$refs.passwordField['type'] == 'password' ? 'text' : 'password';
    this.$refs.passwordField['focus']();
  }

  next() {
    this.doIfFormIsValid(() => {
      this.loading = true;
      const password = (<HTMLInputElement>this.$refs.passwordField).value;

      const clubcardUser = new ClubCardUser({
        firstName: this.$store.state.firstName || this.$store.state.formFirstName,
        lastName: this.$store.state.lastName || this.$store.state.formLastName,
        email: this.$store.state.email,
        password: password,
        phone: this.$store.state.mobileNumber,
        securityAnswer: '',
        clubCard: '',
        securityQuestion: new SecurityQuestion({
          id: '',
          text: ''
        }),
        agreedToMarketing: this.$store.state.agreeComms
      });

      UserApiService.completeRegistration(clubcardUser).then((response) => {
          dataLayer.push({
            'event': 'successfulSubmission',
            'memberStatus': false
          });
        this.autologin(response);
      }).catch((error) => {
        this.handleRegistrationError(error);
      });
    });
  }

  autologin(response: UserRegisterResponse | ClubCardUserResponse) {
    document.location.href = document.location.href + `?customer_id=${encodeURIComponent(response.userId)}&access_token=${encodeURIComponent(response.token)}&anonymous_id=2323&refresh_token=${encodeURIComponent(response.refresh)}&status=${encodeURIComponent(response.status)}`;
    let customerId = response.userId;
    dataLayer.push({
      'event': 'BPIDAvailable',
      'BPID': customerId
    });
  }

  handleRegistrationError(error) {
    if (error && error.response && error.response.data && error.response.data.message) {
      if (error.response.data.message == 'This phone number is not valid') {
        this.invalidateField('phoneNumber', 'This phone number is not valid');
      } else {
        this.handleApiError(error);
      }
    } else {
      this.handleApiError(error);
    }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/forms/fresh-registration/fresh-registration.ts